import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import FetchingStatus from 'constants/statuses/FetchingStatus';

export type FactCheckState = {
  fetching: FetchingStatus | null;
  checkedTime: string | null;
  isUpdating: boolean;
};

const initialState: FactCheckState = {
  fetching: null,
  checkedTime: null,
  isUpdating: false,
};

function setFetchingFunction(state: FactCheckState, action: PayloadAction<FetchingStatus>) {
  return { ...state, fetching: action.payload };
}

function setCheckedTimeFunction(state: FactCheckState, action: PayloadAction<string | null>) {
  return { ...state, checkedTime: action.payload };
}

function setIsUpdatingFunction(state: FactCheckState, action: PayloadAction<boolean>) {
  return { ...state, isUpdating: action.payload };
}

function clearFactCheckFunction(state: FactCheckState) {
  return { ...state, checkedTime: null };
}

const slice = createSlice({
  name: 'hotelManager.factCheck',
  initialState,
  reducers: {
    setFetching: setFetchingFunction,
    setCheckedTime: setCheckedTimeFunction,
    setIsUpdating: setIsUpdatingFunction,
    clearFactCheck: clearFactCheckFunction,
  },
});

export const { setFetching, setCheckedTime, setIsUpdating, clearFactCheck } = slice.actions;

export default slice.reducer;
